import * as ACTIONS from '../actions/metrics';

export const payload = (payload, cb) => ({
  type: ACTIONS.METRICS,
  payload,
  cb,
});
export const sendMetrics = (result, cb) => ({
  type: ACTIONS.SEND_METRICS,
  result,
  cb,
});

export const setMetricsEvent = (forwardingOptions, callback) => (
  dispatch,
  getState,
) => {
  const options = forwardingOptions || {};
  const cb =
    callback ||
    (typeof forwardingOptions === 'function' ? forwardingOptions : undefined);

  if (options.type === 'executor') {
    const { metrics } = getState();
    return dispatch(
      sendMetrics(
        {
          executor: options,
          payload: metrics.payload,
        },
        cb,
      ),
    );
  }

  return dispatch(payload(options, cb));
};
